import React from 'react'

import { A } from '@frame/ui-primitives/a'
import { P } from '@frame/ui-primitives/p'

import { useFileUploadContext } from '@documents/contexts/file-upload-context'
import { DataAttribute } from '@frame/types'

export function FileUpload() {
  const {
    dropzone: { open, getRootProps, getInputProps },
  } = useFileUploadContext()

  return (
    <div
      data-cy={DataAttribute.FILE_UPLOADER}
      {...getRootProps({ className: 'dropzone' })}
      className="flex w-full grow cursor-pointer flex-col items-center justify-center rounded-sm border border-dashed border-moss-300 bg-moss-100 p-4"
      onClick={open}
    >
      <input {...getInputProps()} type="file" />
      <P>
        Drag and drop here or <A className="select-none">upload file(s)</A>
      </P>
    </div>
  )
}
